/**
 * What one indexed row *is*, so a count can say so.
 *
 * The two tiers count different things — a batch at a stage, a leg of an EPC delta — and both used to render
 * as "N rows". That is not a wording preference: side by side, two counts in the same unit read as two
 * measurements of one population, and a reader comparing `412 rows` of batch staging against `412 rows` of
 * delta chain has no way to see that the second number is legs and could not have been the first. Naming the
 * unit is the only thing that makes the two columns non-comparable on sight, which they are.
 *
 * Both forms are stored rather than derived, because English plurals are not a suffix rule and this file is
 * the wrong place to find that out later. Callers that already have the noun in their sentence still need the
 * pair, so the singular is not merely the plural minus an `s`.
 */
export interface RowUnit {
  one: string;
  many: string;
}

/**
 * A count with its unit attached: `1 batch`, `412 batches`.
 *
 * Localised, for the reason every other count on these panels is: five figures without a separator is a
 * number a reader has to spell out before they can compare it to the one beside it.
 */
export const countOf = (count: number, unit: RowUnit): string =>
  `${count.toLocaleString()} ${count === 1 ? unit.one : unit.many}`;
